import styled from 'styled-components';

export default styled.div`
  grid-area: total_diff_ips;
`;
